module.exports = __webpack_public_path__ + "img/blue-square-table-2.50606f78.png";